import styles from "./Review.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { useMutation, useQuery } from '@apollo/client';
import {
    ASSESSMENT_ANSWERS, ASSESSMENT_BY_ID,
    ASSESSMENT_QUESTIONS, ASSESSMENT_RENDERED_PDF, ASSESSMENT_VERSIONS,
    ASSESSMENTS_MINIMAL,
    ORGANISATION_LIST, SAVE_ASSESSMENT_ANSWERS,
    TAG_SUGGESTIONS
} from '../../apollo/queries';
import React, { useRef, useState } from 'react';
import Select, { MultiValue, SingleValue } from 'react-select';
import moment from 'moment';
import { customStyles } from '../../components/DataTable/customStyles';
import { RequestAssessment } from '../../components/RequestAssessment';
import { ShareAssessment } from '../../components/ShareAssessment';
import { RemindAssesssment } from '../../components/RemindAssessment';
import { Input } from '../../components/common/Input';
import { Button } from '../../components/common/Button';
import { MultiSelect, MyOptionType } from '../../components/common/MultiSelect';
import DataTable from 'react-data-table-component';
import { useLazyQuery } from '@apollo/react-hooks';
import { client } from '../../apollo/client';
import { ChangeAssessmentAnswersModal } from '../../components/ChangeAssessmentAnswersModal';
import { ShareReview } from '../../components/ShareReview';
import { useLocation, useParams } from 'react-router-dom';
import { uuid } from 'short-uuid';
import Loader from "../../components/common/Loader";


interface ListItem {
    id: Number
    name: String
}

const TYPE_ASSESSMENT = 'ASSESSMENT'
const TYPE_QUESTIONNAIRE = 'QUESTIONNAIRE'

const mapToSelectList = (objects: ListItem[]) => {
    return objects.map((object: ListItem) => {
        return {
            label: object.name,
            value: object.id
        }
    })
}

export const Review  = () => {
    const [isActive, setActive] = useState(true)
    const params = useParams()
    const selectRef = useRef(null)
    const [tableType, setTableType] = useState(TYPE_ASSESSMENT);
    const [assessments, setAssessments] = useState<MyOptionType[] | []>([]);
    const [assessmentQuestionnaireData, setAssessmentQuestionnaireData] = useState<[]>([]);
    const [institutions, setInstitutions] = useState<MyOptionType[] | []>([]);
    const [labels, setLabels] = useState<MyOptionType[] | []>([]);
    const [renderedPdfResult, setRenderedPdfResult] = useState<string | undefined>(undefined);
    const [selectedInstitutions, setSelectedInstitutions] = useState<MultiValue<MyOptionType>| []>([]);
    const [selectedLabels, setSelectedLabels] = useState<MultiValue<MyOptionType>| []>([]);
    const [selectedAssessment, setSelectedAssessment] = useState<SingleValue<MyOptionType>>(null);
    const [reportPdf, setReportPdf] = useState<string|null>(null)
    const [questionnairePdf, setQuestionnairePdf] = useState<string|null>(null)
    const [reviewedPdfUrl, setReviewedPdfUrl] = useState<string|null>(null)
    const [reviewedQuestionnairePdfUrl, setReviewedQuestionnairePdfUrl] = useState<string|null>(null)
    const [assessmentIdUuids, setAssessmentIdUuids] = useState<[]>([])
    const [selectedAssessmentUuid, setSelectedAssessmentUuid] = useState<string | null>(null)
    const [assessmentVersions, setAssessmentVersions] = useState<[]>([])
    const [savedAnswerAndQuestionCount, setSavedAnswerAndQuestionCount] = useState(null)
    const [selectedAssessmentVersion, setSelectedAssessmentVersion] = useState<SingleValue<MyOptionType>>(null);
    const [changeAnswersOpen, setChangeAnswersOpen] = useState<boolean>(false)
    const [shareReview, setShareReview] = useState(false)
    const [disabledReviewButton, setDisabledReviewButton] = useState(false)

    useQuery(TAG_SUGGESTIONS, {
        onCompleted: (data) => {
            setLabels(mapToSelectList(data.tagSuggestions))
        },
        fetchPolicy: "no-cache"
    })

    useQuery(ORGANISATION_LIST, {
        variables: {
            type: 'STARTUP'
        },
        onCompleted: (data) => {
            setInstitutions(mapToSelectList(data.myOrganisationList))
        },
        fetchPolicy: "no-cache"
    })

    useQuery(ASSESSMENTS_MINIMAL, {
        onCompleted: async (someData) => {
            // @ts-ignore
            let subset = someData.assessmentsMinimal.map((assessment) => {
                return {
                    label: `${assessment.venture} - ${moment(assessment.completionTime).format('YYYY-MM-DD HH:mm')} (${assessment.scanType})`,
                    value: assessment.id
                }
            })
            subset = subset.sort((itemA: MyOptionType, itemB: MyOptionType) => {
                if (itemA.label.toLowerCase() < itemB.label.toLowerCase()) {
                    return -1;
                }
                if (itemA.label.toLowerCase() > itemB.label.toLowerCase()) {
                    return 1;
                }
                return 0;
            })
            setAssessments(subset)
            // @ts-ignore
            const array = [];
            // @ts-ignore
            let selectedId = null
            for(const assessment of someData.assessmentsMinimal) {
                array[assessment.id] = assessment.uuid
                if(params?.assessmentUuid && params?.assessmentUuid === assessment.uuid) {
                    selectedId = assessment.id
                }
            }

            // @ts-ignore
            setAssessmentIdUuids(array)

            if(selectedId !== null) {
                // @ts-ignore
                const item = subset.filter((item:MyOptionType) => item.value === selectedId)
                setSelectedAssessment(item[0])
                // @ts-ignore
                await updateData(item[0].value, array)
            }

            setActive(value => !value)

        },
        fetchPolicy: "no-cache"
    });

    const [saveUpdatedAnswers] = useMutation(SAVE_ASSESSMENT_ANSWERS)

    const [getAssessmentData] = useLazyQuery(ASSESSMENT_BY_ID, {
        fetchPolicy: 'no-cache'
    })
    const [getVersions] = useLazyQuery(ASSESSMENT_VERSIONS, {
        fetchPolicy: 'no-cache'
    })

    const getAssessmentDocuments = async (id: number | string) => {
        const result = await getAssessmentData({
            variables: {
                // @ts-ignore
                assessmentId: typeof id === 'number' ? id : parseInt(id)
            },
            fetchPolicy: 'no-cache'
        })
        // @ts-ignore
        console.log(result.data.assessment)

        return {
            reportPdf: result.data.assessment.pdfUrl ? result.data.assessment.pdfUrl + '?' + uuid() : null,
            questionnairePdf: result.data.assessment.questionnairePdfUrl ? result.data.assessment.questionnairePdfUrl + '?' + uuid() : null,
            reviewedPdfUrl: result.data.assessment.reviewedPdfUrl ? result.data.assessment.reviewedPdfUrl + '?' + uuid() : null,
            reviewedQuestionnairePdfUrl: result.data.assessment.reviewedQuestionnairePdfUrl ? result.data.assessment.reviewedQuestionnairePdfUrl + '?' + uuid() : null,
        }
    }

    const getAssessmentVersions = async(uuid: string)=> {
        const versions = await getVersions({
            variables: {
                uuid: uuid
            },
            fetchPolicy: 'no-cache',
            onCompleted: (() => {
                setDisabledReviewButton(false)
            }),
            onError: (() => {
                setDisabledReviewButton(true)
            })
        })

        // @ts-ignore
        return versions.data.assessmentVersions
    }

    // @ts-ignore
    const updateData = async (assessmentId, idArray = [], uuidGiven = null) => {
        const idArrayConvertor = idArray.length > 0 && idArray ? idArray : assessmentIdUuids
        const uuid = uuidGiven ? uuidGiven : idArrayConvertor[assessmentId]

        console.log({
            choices:  idArrayConvertor,
            setter: uuid
        })
        // @ts-ignore
        setSelectedAssessmentUuid(uuid)

        // @ts-ignore
        const data = await getAssessmentDocuments(assessmentId)

        // @ts-ignore
        let versions = await getAssessmentVersions(uuid)
        versions = versions.map((version: Number) => {
            return {
                label: version === 0 ? 'Original version' : 'Reviewed version',
                value: version
            }
        })
        setAssessmentVersions(versions)
        const lastVersion = versions[versions.length - 1]
        setSelectedAssessmentVersion(lastVersion)
        setReportPdf(data.reportPdf)
        setQuestionnairePdf(data.reviewedQuestionnairePdfUrl)
        setReviewedPdfUrl(data.reviewedPdfUrl)
        setReviewedQuestionnairePdfUrl(data.reviewedQuestionnairePdfUrl)
    }

    // @ts-ignore
    const getUpdatedAnswers = async (answers) => {
        await saveUpdatedAnswers({
            variables: {
                input: {
                    assessmentUuid: selectedAssessmentUuid,
                    answers,
                    version: 1
                }
            },
            fetchPolicy: 'network-only'
        }).then((data) => {
            // @ts-ignore
            if(data.data.saveAssessmentAnswers.questionCount <= data.data.saveAssessmentAnswers.answerCount) {
                setChangeAnswersOpen(!changeAnswersOpen)
                setSavedAnswerAndQuestionCount(null)
            } else {
                setSavedAnswerAndQuestionCount({
                    // @ts-ignore
                    questionCount: data.data.saveAssessmentAnswers.questionCount,
                    // @ts-ignore
                    answerCount: data.data.saveAssessmentAnswers.answerCount,
                })
            }
            let id = null
            for(const key in assessmentIdUuids) {
                if(assessmentIdUuids[key] === selectedAssessmentUuid) {
                    id = key;
                }
            }

            console.log({
                selectedAssessmentUuid,
                // @ts-ignore
                id: id,
                reversed: assessmentIdUuids.reverse(),
                array: assessmentIdUuids
            })

            // @ts-ignore
            updateData(id, [], selectedAssessmentUuid)
        })
    }



    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Company Review" subtitle=''/>
            <Loader active={isActive}>
                <div className={styles.wrapper}>
                    <ShareAssessment isOpen={shareReview} onOpenChange={(isOpen: boolean) => {
                        setShareReview(isOpen)
                        // @ts-ignore
                    }} shareContent={
                        {
                            // @ts-ignore
                            id: parseInt(selectedAssessment?.value),
                            companyName: selectedAssessment?.label.split(' - ')[0] ?? '',
                            assessmentDate: selectedAssessment?.label.split(' - ')[1].split(' (')[0] ?? '',
                            scanType: selectedAssessment?.label.split(' - ')[1].split(' (')[1].replace(')', '') ?? '',
                        }
                    }/>
                    {/*<ShareReview*/}
                    {/*    assessmentUuid={selectedAssessmentUuid ?? ''}*/}
                    {/*    isOpen={shareReview}*/}
                    {/*    onOpenChange={(isOpen: boolean) => {*/}
                    {/*        setShareReview(isOpen)*/}
                    {/*    }}*/}
                    {/*/>*/}
                    <ChangeAssessmentAnswersModal
                        assessmentUuid={selectedAssessmentUuid}
                        isOpen={changeAnswersOpen}
                        button={true}
                        getUpdatedAnswers={getUpdatedAnswers}
                        counts={savedAnswerAndQuestionCount}
                        version={selectedAssessmentVersion ? selectedAssessmentVersion?.value as number : 0}
                        onOpenChange={(isOpen: boolean) => {
                            if(!isOpen) {
                                setSavedAnswerAndQuestionCount(null)
                            }
                            setChangeAnswersOpen(isOpen)
                        }}
                    />

                    <div className={styles.formContainer}>
                        <div className={styles.selectWrapper}>
                            {/*<div className={styles.selectContainer}>*/}
                            {/*    { labels.length > 0 &&*/}
                            {/*        <MultiSelect*/}
                            {/*            options={labels}*/}
                            {/*            placeHolder={'Select labels'}*/}
                            {/*            value={selectedLabels}*/}
                            {/*            onChangeSelected={setSelectedLabels}*/}
                            {/*        />*/}
                            {/*    }*/}
                            {/*</div>*/}
                            <div className={styles.selectContainer}>
                                { assessments.length > 0 &&
                                    <Select
                                        ref={selectRef}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        options={assessments}
                                        placeholder={'Select assessment'}
                                        value={selectedAssessment}
                                        onChange={async (e) => {
                                            setSelectedAssessment(e)
                                            if(e?.value) {
                                                // @ts-ignore
                                                setSelectedAssessmentUuid(assessmentIdUuids[e?.value])
                                                await updateData(parseInt(e?.value.toString()), [], assessmentIdUuids[parseInt(e?.value.toString())])
                                            }
                                        }}
                                    />
                                }
                            </div>
                            <div className={styles.selectContainer}>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    options={assessmentVersions}
                                    placeholder={'Version'}
                                    value={selectedAssessmentVersion}
                                    onChange={async (e) => {
                                        setSelectedAssessmentVersion(e)
                                    }}
                                />
                            </div>

                            <div className={styles.selectContainer}>
                                <div className={styles.buttonsRight}>
                                    <Button
                                        type="button"
                                        className={ 'dark' }
                                        title={ 'Check / review answers' }
                                        onClick={() => {
                                            if(selectedAssessment) {
                                                setChangeAnswersOpen(true)
                                            }
                                        }}>
                                        Review Answers
                                    </Button>
                                    <Button
                                        type="button"
                                        className={'dark'}
                                        disabled={disabledReviewButton}
                                        title={ 'Share'}
                                        onClick={() => {
                                            setShareReview(true)
                                        }}>
                                        Share
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className={styles.filterButtons}>
                            {/*<Button*/}
                            {/*    type="button"*/}
                            {/*    className={ tableType === TYPE_ASSESSMENT ? 'dark' : 'primaryBordered'}*/}
                            {/*    title={ tableType === TYPE_ASSESSMENT ? '' : 'Report'}*/}
                            {/*    onClick={ async() => {*/}
                            {/*        setTableType(TYPE_ASSESSMENT)*/}
                            {/*    }}>*/}
                            {/*    Report*/}
                            {/*</Button>*/}
                            {/*<Button*/}
                            {/*    type="button"*/}
                            {/*    className={ tableType === TYPE_QUESTIONNAIRE ? 'dark' : 'primaryBordered'}*/}
                            {/*    title={ tableType === TYPE_QUESTIONNAIRE ? '' : 'Answers'}*/}
                            {/*    onClick={() => {*/}
                            {/*        setTableType(TYPE_QUESTIONNAIRE)*/}
                            {/*    }}>*/}
                            {/*    Questionnaire*/}
                            {/*</Button>*/}
                        </div>
                        <div className={styles.resultContainer}>
                            {
                                tableType === TYPE_ASSESSMENT && selectedAssessmentVersion?.value === 0 && reportPdf && (
                                    <iframe className={styles.documentWrapper} src={reportPdf} style={{width: '100%', height: "100vh"}}/>
                                    // <DataTable
                                    //     customStyles={customStyles}
                                    //     // @ts-ignore
                                    //     columns={[
                                    //         {
                                    //             name: 'Question',
                                    //             id: 'question',
                                    //             // @ts-ignore
                                    //             selector: row => {
                                    //                 // @ts-ignore
                                    //                 return row.question
                                    //             },
                                    //             sortable: true,
                                    //             wrap: true,
                                    //             width: '40%',
                                    //         },
                                    //         {
                                    //             name: 'Option',
                                    //             id: 'option',
                                    //             // @ts-ignore
                                    //             selector: row => row.option,
                                    //             // @ts-ignore
                                    //             format: row => {
                                    //                 // @ts-ignore
                                    //                 if(row.option && row.option.length) {
                                    //                     // @ts-ignore
                                    //                     return row.option.join('<br/>')
                                    //                 }
                                    //                 // @ts-ignore
                                    //                 return row.option
                                    //             },
                                    //             sortable: true,
                                    //             width: '20%',
                                    //             wrap: true
                                    //
                                    //         },
                                    //         {
                                    //             name: 'Answer',
                                    //             id: 'answer',
                                    //             // @ts-ignore
                                    //             selector: row => {
                                    //                 // @ts-ignore
                                    //                 if(row.answer) return row.answer
                                    //             },
                                    //             // @ts-ignore
                                    //             cell: row => {
                                    //                 // @ts-ignore
                                    //                 if(row.answer && Array.isArray(row.answer)) {
                                    //                     // @ts-ignore
                                    //                     console.log(row.answer)
                                    //                     // @ts-ignore
                                    //                     return row.answer.map(answer => <p className={styles.spacer} dangerouslySetInnerHTML={{__html: answer}} />)
                                    //                 }
                                    //                 // @ts-ignore
                                    //                 return row.answer
                                    //             },
                                    //             sortable: true,
                                    //             width: '40%',
                                    //             wrap: true
                                    //         }
                                    //     ]}
                                    //     data={assessmentQuestionnaireData}
                                    //     defaultSortFieldId="createdAt"
                                    //     defaultSortAsc={false}
                                    //     highlightOnHover
                                    //     noDataComponent={<div style={{ padding: '40px' }}>No assessment selected</div>}
                                    //     // rowKey="id"
                                    //     fixedHeader={true}
                                    //     fixedHeaderScrollHeight={'800px'}
                                    // />
                                )
                            }
                            {
                                tableType === TYPE_ASSESSMENT && selectedAssessmentVersion?.value === 1 && reviewedPdfUrl && (
                                    <iframe className={styles.documentWrapper} src={reviewedPdfUrl} style={{width: '100%', height: "100vh"}}/>
                                )
                            }
                            {
                                tableType === TYPE_ASSESSMENT && (
                                    (!reportPdf && selectedAssessmentVersion?.value === 0) || (!reviewedPdfUrl && selectedAssessmentVersion?.value === 1)
                                ) && (
                                    <div style={{ padding: '40px', width: '100%', textAlign: 'center', background: '#fff' }}>No assessment selected</div>
                                )
                            }
                            {
                                tableType === TYPE_QUESTIONNAIRE && selectedAssessmentVersion?.value === 0 && questionnairePdf && (
                                    <iframe className={styles.documentWrapper} src={questionnairePdf} style={{width: '100%', height: "100vh"}}/>
                                    // <embed style={{width: '100%', height: "100vh"}} src={`data:application/pdf;base64,${renderedPdfResult}`} />
                                )
                            }
                            {
                                tableType === TYPE_QUESTIONNAIRE && selectedAssessmentVersion?.value === 1 && reviewedQuestionnairePdfUrl && (
                                    <iframe className={styles.documentWrapper} src={reviewedQuestionnairePdfUrl} style={{width: '100%', height: "100vh"}}/>
                                    // <embed style={{width: '100%', height: "100vh"}} src={`data:application/pdf;base64,${renderedPdfResult}`} />
                                )
                            }
                            {
                                tableType === TYPE_QUESTIONNAIRE && !questionnairePdf && (
                                    <div style={{ padding: '40px', width: '100%', textAlign: 'center', background: '#fff' }}>No assessment selected</div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </Loader>
        </div>
)
};

const initialFormValues = {
    search: "",
};
